import React from 'react';
import { Grid, IconButton, InputAdornment, Link, TextField, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSnackbar } from '../../context/snackbar-context';

interface SupplierProfileUrlProps {
  profileUrl: string;
}

const SupplierProfileUrl = ({ profileUrl }: SupplierProfileUrlProps) => {
  const { snackbarShowMessage } = useSnackbar();
  const fullUrl = new URL(profileUrl, window.location.origin).toString();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      snackbarShowMessage('Copied to clipboard!', 'success', 3000);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to copy supplier profile URL to clipboard.', err);
      }
      snackbarShowMessage('Failed to copy URL', 'error', 3000);
    }
  };

  return (
    <Grid item container direction="column" component="section" sx={{ rowGap: '0.71rem', mt: '1.43rem' }}>
      <Typography variant="h6" color="textPrimary">Your Public Profile</Typography>
      <TextField
        variant="standard"
        value={fullUrl}
        label="Profile URL"
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Copy profile URL"
                onClick={handleCopy}
                edge="end"
                size="small"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Link
        href={fullUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Public Profile
      </Link>
    </Grid>
  );
};

export default SupplierProfileUrl;
